export default "__VITE_ASSET__CndSt0ZR__"